export default __webpack_public_path__ + "static/media/ellipsis.b0475511.svg";